import PropTypes from 'prop-types';

export const QuizDataType = {
    id: PropTypes.number,
    description: PropTypes.string,
    type: PropTypes.string,
    required: PropTypes.number
};
